import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" };
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" };
const _hoisted_3 = { class: "d-sm-flex align-items-center" };
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25" };
const _hoisted_5 = { class: "table-responsive" };
const _hoisted_6 = { class: "table text-nowrap align-middle mb-0" };
const _hoisted_7 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_8 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_9 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_10 = { key: 0 };
const _hoisted_11 = {
    colspan: "8",
    class: "text-center py-4"
};
const _hoisted_12 = { class: "shadow-none lh-1 fw-medium ps-0" };
const _hoisted_13 = {
    key: 0,
    class: "badge bg-primary-light text-primary p-2"
};
const _hoisted_14 = {
    key: 1,
    class: "badge bg-info-light text-info p-2"
};
const _hoisted_15 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" };
const _hoisted_16 = { class: "fw-bold" };
const _hoisted_17 = {
    key: 0,
    class: "text-muted"
};
const _hoisted_18 = { class: "shadow-none lh-1 fw-medium text-muted" };
const _hoisted_19 = {
    key: 0,
    class: "badge bg-light text-dark border"
};
const _hoisted_20 = {
    key: 1,
    class: "badge bg-light text-dark border"
};
const _hoisted_21 = { class: "shadow-none lh-1 fw-medium text-muted" };
const _hoisted_22 = { class: "small" };
const _hoisted_23 = {
    key: 0,
    class: "badge bg-light text-dark border"
};
const _hoisted_24 = {
    key: 1,
    class: "badge bg-light text-dark border"
};
const _hoisted_25 = { class: "mt-1" };
const _hoisted_26 = { class: "shadow-none lh-1 fw-medium" };
const _hoisted_27 = { class: "shadow-none lh-1 fw-medium text-muted" };
const _hoisted_28 = { key: 0 };
const _hoisted_29 = { class: "mb-2" };
const _hoisted_30 = { class: "text-success fw-bold" };
const _hoisted_31 = { class: "d-flex gap-3" };
const _hoisted_32 = { key: 0 };
const _hoisted_33 = { class: "text-info fw-bold" };
const _hoisted_34 = { key: 1 };
const _hoisted_35 = { class: "text-primary fw-bold" };
const _hoisted_36 = { key: 1 };
const _hoisted_37 = { class: "badge bg-warning-light text-warning" };
const _hoisted_38 = { key: 2 };
const _hoisted_39 = {
    key: 3,
    class: "text-center"
};
const _hoisted_40 = { class: "shadow-none lh-1 fw-medium text-muted" };
const _hoisted_41 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" };
const _hoisted_42 = { class: "dropdown" };
const _hoisted_43 = { class: "dropdown-menu" };
const _hoisted_44 = ["onClick"];
const _hoisted_45 = { key: 0 };
const _hoisted_46 = ["onClick"];
const _hoisted_47 = ["onClick"];
const _hoisted_48 = ["onClick"];
const _hoisted_49 = { key: 2 };
const _hoisted_50 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" };
const _hoisted_51 = { class: "mb-0 text-paragraph" };
const _hoisted_52 = { class: "mt-15 mt-md-0" };
const _hoisted_53 = { class: "pagination mb-0" };
const _hoisted_54 = ["onClick"];
const _hoisted_55 = {
    class: "modal fade",
    id: "confirmModal",
    tabindex: "-1",
    "aria-labelledby": "confirmModalLabel",
    "aria-hidden": "true"
};
const _hoisted_56 = { class: "modal-dialog modal-dialog-centered" };
const _hoisted_57 = { class: "modal-content" };
const _hoisted_58 = { class: "modal-body text-center" };
const _hoisted_59 = { class: "mb-0" };
const _hoisted_60 = { class: "modal-footer" };
const _hoisted_61 = {
    type: "button",
    class: "btn btn-secondary",
    "data-bs-dismiss": "modal"
};
const _hoisted_62 = {
    class: "modal fade",
    id: "reportModal",
    tabindex: "-1",
    "aria-hidden": "true"
};
const _hoisted_63 = { class: "modal-dialog modal-lg modal-dialog-centered" };
const _hoisted_64 = { class: "modal-content border-0 shadow-lg" };
const _hoisted_65 = { class: "modal-header bg-primary text-white border-0" };
const _hoisted_66 = { class: "modal-title text-white" };
const _hoisted_67 = { class: "modal-body p-4" };
const _hoisted_68 = {
    key: 0,
    class: "text-center py-5"
};
const _hoisted_69 = { key: 1 };
const _hoisted_70 = { class: "row g-3 mb-4" };
const _hoisted_71 = { class: "col-md-4" };
const _hoisted_72 = { class: "p-3 bg-light rounded-3 text-center" };
const _hoisted_73 = { class: "fw-bold text-success mb-1" };
const _hoisted_74 = { class: "col-md-4" };
const _hoisted_75 = { class: "p-3 bg-light rounded-3 text-center" };
const _hoisted_76 = { class: "fw-bold text-info mb-1" };
const _hoisted_77 = { class: "col-md-4" };
const _hoisted_78 = { class: "p-3 bg-light rounded-3 text-center" };
const _hoisted_79 = { class: "fw-bold text-primary mb-1" };
const _hoisted_80 = {
    class: "table-responsive",
    style: { "max-height": "400px" }
};
const _hoisted_81 = { class: "table table-hover align-middle" };
const _hoisted_82 = { class: "fw-medium" };
const _hoisted_83 = { class: "text-end text-muted small" };
const _hoisted_84 = { key: 0 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_LoaderComponent = _resolveComponent("LoaderComponent");
    const _component_EmptyTable = _resolveComponent("EmptyTable");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("button", {
                        onClick: _cache[0] || (_cache[0] =
                            //@ts-ignore
                            (...args) => (_ctx.gotoCreate && _ctx.gotoCreate(...args))),
                        class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
                        type: "button"
                    }, [
                        _createTextVNode(_toDisplayString(_ctx.$t('lists.addCampaign')) + " ", 1),
                        _cache[4] || (_cache[4] = _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1))
                    ])
                ])
            ]),
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("table", _hoisted_6, [
                        _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                                _cache[5] || (_cache[5] = _createElementVNode("th", {
                                    scope: "col",
                                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
                                }, " Type ", -1)),
                                _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t('lists.campaignTitle')), 1),
                                _cache[6] || (_cache[6] = _createElementVNode("th", {
                                    scope: "col",
                                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                                }, " Canal ", -1)),
                                _cache[7] || (_cache[7] = _createElementVNode("th", {
                                    scope: "col",
                                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                                }, " Cible ", -1)),
                                _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t('lists.campaignStatus')), 1),
                                _cache[8] || (_cache[8] = _createElementVNode("th", {
                                    scope: "col",
                                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                                }, " Performance ", -1)),
                                _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t('lists.campaignCreatedAt')), 1),
                                _cache[9] || (_cache[9] = _createElementVNode("th", {
                                    scope: "col",
                                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                                }, null, -1))
                            ])
                        ]),
                        _createElementVNode("tbody", null, [
                            (_ctx.isLoading)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                                    _createElementVNode("td", _hoisted_11, [
                                        _createVNode(_component_LoaderComponent)
                                    ])
                                ]))
                                : (!_ctx.isLoading && _ctx.allCategorie.length > 0)
                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.allCategorie, (categorie) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                            key: categorie.id
                                        }, [
                                            _createElementVNode("td", _hoisted_12, [
                                                (categorie.type === 'email')
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, [...(_cache[10] || (_cache[10] = [
                                                            _createElementVNode("i", { class: "fas fa-envelope" }, null, -1)
                                                        ]))]))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_14, [...(_cache[11] || (_cache[11] = [
                                                            _createElementVNode("i", { class: "fas fa-mobile-alt" }, null, -1)
                                                        ]))]))
                                            ]),
                                            _createElementVNode("td", _hoisted_15, [
                                                _createElementVNode("div", _hoisted_16, _toDisplayString(categorie.title), 1),
                                                (categorie.subject)
                                                    ? (_openBlock(), _createElementBlock("small", _hoisted_17, _toDisplayString(categorie.subject), 1))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            _createElementVNode("td", _hoisted_18, [
                                                (categorie.target_filters?.restaurant_name)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(categorie.target_filters.restaurant_name), 1))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_20, " Tous "))
                                            ]),
                                            _createElementVNode("td", _hoisted_21, [
                                                _createElementVNode("div", _hoisted_22, [
                                                    (categorie.target_filters?.is_global)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_23, "Global"))
                                                        : (_openBlock(), _createElementBlock("span", _hoisted_24, "Local")),
                                                    _createElementVNode("div", _hoisted_25, _toDisplayString(categorie.target_filters?.audience_type === 'newsletter' ? 'Newsletter' : 'Tous'), 1)
                                                ])
                                            ]),
                                            _createElementVNode("td", _hoisted_26, [
                                                _createElementVNode("span", {
                                                    class: _normalizeClass([_ctx.getStatusClass(categorie.status), "badge fs-13"])
                                                }, _toDisplayString(_ctx.getCampaignStatusTranslation(categorie.status)), 3)
                                            ]),
                                            _createElementVNode("td", _hoisted_27, [
                                                (categorie.status === 'sent' || categorie.status === 'delivered' || (categorie.delivered_count > 0))
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                                        _createElementVNode("div", _hoisted_29, [
                                                            _createElementVNode("span", _hoisted_30, _toDisplayString(categorie.delivered_count || 0), 1),
                                                            _cache[12] || (_cache[12] = _createTextVNode()),
                                                            _cache[13] || (_cache[13] = _createElementVNode("small", null, "livrés", -1))
                                                        ]),
                                                        _createElementVNode("div", _hoisted_31, [
                                                            (categorie.opened_count >= 0)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                                                    _createElementVNode("span", _hoisted_33, _toDisplayString(categorie.opened_count || 0), 1),
                                                                    _cache[14] || (_cache[14] = _createElementVNode("small", { class: "d-block text-xs" }, "Ouverts", -1))
                                                                ]))
                                                                : _createCommentVNode("", true),
                                                            (categorie.clicked_count >= 0)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                                                    _createElementVNode("span", _hoisted_35, _toDisplayString(categorie.clicked_count || 0), 1),
                                                                    _cache[15] || (_cache[15] = _createElementVNode("small", { class: "d-block text-xs" }, "Clics", -1))
                                                                ]))
                                                                : _createCommentVNode("", true)
                                                        ])
                                                    ]))
                                                    : (categorie.status === 'scheduled')
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                                            _createElementVNode("span", _hoisted_37, [
                                                                _cache[16] || (_cache[16] = _createElementVNode("i", { class: "far fa-clock me-1" }, null, -1)),
                                                                _createTextVNode(" " + _toDisplayString(_ctx.convertDateCreate(categorie.scheduled_at, "dd/MM HH:mm")), 1)
                                                            ])
                                                        ]))
                                                        : (categorie.status === 'processing')
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [...(_cache[17] || (_cache[17] = [
                                                                    _createElementVNode("div", {
                                                                        class: "spinner-border spinner-border-sm text-primary me-1",
                                                                        role: "status"
                                                                    }, null, -1),
                                                                    _createElementVNode("span", { class: "text-primary animated-pulse" }, "Envoi en cours...", -1)
                                                                ]))]))
                                                            : (_openBlock(), _createElementBlock("div", _hoisted_39, "-"))
                                            ]),
                                            _createElementVNode("td", _hoisted_40, _toDisplayString(_ctx.convertDateCreate(categorie.created_at, "dd/MM/yy HH:mm")), 1),
                                            _createElementVNode("td", _hoisted_41, [
                                                _createElementVNode("div", _hoisted_42, [
                                                    _cache[22] || (_cache[22] = _createElementVNode("button", {
                                                        class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                                                        type: "button",
                                                        "data-bs-toggle": "dropdown",
                                                        "aria-expanded": "false"
                                                    }, [
                                                        _createElementVNode("i", { class: "flaticon-dots" })
                                                    ], -1)),
                                                    _createElementVNode("ul", _hoisted_43, [
                                                        _createElementVNode("li", null, [
                                                            _createElementVNode("a", {
                                                                class: "dropdown-item d-flex align-items-center",
                                                                href: "javascript:void(0)",
                                                                onClick: ($event) => (_ctx.openReport(categorie)),
                                                                "data-bs-toggle": "modal",
                                                                "data-bs-target": "#reportModal"
                                                            }, [...(_cache[18] || (_cache[18] = [
                                                                    _createElementVNode("i", { class: "fas fa-chart-line me-2 text-primary" }, null, -1),
                                                                    _createTextVNode(" Rapport détaillé ", -1)
                                                                ]))], 8, _hoisted_44)
                                                        ]),
                                                        (categorie.status === 'draft')
                                                            ? (_openBlock(), _createElementBlock("li", _hoisted_45, [
                                                                _createElementVNode("a", {
                                                                    class: "dropdown-item d-flex align-items-center text-success",
                                                                    href: "javascript:void(0);",
                                                                    onClick: ($event) => (_ctx.sendAction(categorie))
                                                                }, [...(_cache[19] || (_cache[19] = [
                                                                        _createElementVNode("i", { class: "flaticon-chevron lh-1 me-8 position-relative top-1" }, null, -1),
                                                                        _createTextVNode(" Lancer maintenant", -1)
                                                                    ]))], 8, _hoisted_46)
                                                            ]))
                                                            : _createCommentVNode("", true),
                                                        _createElementVNode("li", null, [
                                                            _createElementVNode("a", {
                                                                class: "dropdown-item d-flex align-items-center",
                                                                href: "javascript:void(0);",
                                                                onClick: ($event) => (_ctx.selectForDetail(categorie))
                                                            }, [
                                                                _cache[20] || (_cache[20] = _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1)),
                                                                _createTextVNode(" " + _toDisplayString(_ctx.$t('lists.view')), 1)
                                                            ], 8, _hoisted_47)
                                                        ]),
                                                        _createElementVNode("li", null, [
                                                            _createElementVNode("a", {
                                                                class: "dropdown-item d-flex align-items-center text-danger",
                                                                href: "javascript:void(0);",
                                                                "data-bs-toggle": "modal",
                                                                "data-bs-target": "#confirmModal",
                                                                onClick: ($event) => (_ctx.selectForDelete(categorie))
                                                            }, [
                                                                _cache[21] || (_cache[21] = _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1)),
                                                                _createTextVNode(" " + _toDisplayString(_ctx.$t('lists.delete')), 1)
                                                            ], 8, _hoisted_48)
                                                        ])
                                                    ])
                                                ])
                                            ])
                                        ]));
                                    }), 128))
                                    : (_openBlock(), _createElementBlock("tr", _hoisted_49, [
                                        _createVNode(_component_EmptyTable, {
                                            message: _ctx.$t('lists.noCampaigns'),
                                            colspan: 8,
                                            textClass: "text-muted"
                                        }, null, 8, ["message"])
                                    ]))
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("p", _hoisted_51, _toDisplayString(_ctx.paginationInfo), 1),
                    _createElementVNode("nav", _hoisted_52, [
                        _createElementVNode("ul", _hoisted_53, [
                            _createElementVNode("li", {
                                class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === 1 }])
                            }, [
                                _createElementVNode("a", {
                                    class: "page-link",
                                    href: "#",
                                    "aria-label": "Previous",
                                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (_ctx.changePage(_ctx.currentPage - 1)), ["prevent"]))
                                }, [...(_cache[23] || (_cache[23] = [
                                        _createElementVNode("i", { class: "flaticon-chevron-1" }, null, -1)
                                    ]))])
                            ], 2),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.generatePageNumbers(), (page) => {
                                return (_openBlock(), _createElementBlock("li", {
                                    key: page,
                                    class: _normalizeClass(["page-item", { active: page === _ctx.currentPage }])
                                }, [
                                    _createElementVNode("a", {
                                        class: "page-link",
                                        href: "#",
                                        onClick: _withModifiers(($event) => (_ctx.changePage(page)), ["prevent"])
                                    }, _toDisplayString(page), 9, _hoisted_54)
                                ], 2));
                            }), 128)),
                            _createElementVNode("li", {
                                class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === _ctx.totalPages }])
                            }, [
                                _createElementVNode("a", {
                                    class: "page-link",
                                    href: "#",
                                    "aria-label": "Next",
                                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (_ctx.changePage(_ctx.currentPage + 1)), ["prevent"]))
                                }, [...(_cache[24] || (_cache[24] = [
                                        _createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
                                    ]))])
                            ], 2)
                        ])
                    ])
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_55, [
            _createElementVNode("div", _hoisted_56, [
                _createElementVNode("div", _hoisted_57, [
                    _cache[29] || (_cache[29] = _createElementVNode("div", { class: "modal-header" }, [
                        _createElementVNode("h5", {
                            class: "modal-title",
                            id: "confirmModalLabel"
                        }, " Confirmation de suppression "),
                        _createElementVNode("button", {
                            type: "button",
                            class: "btn-close",
                            "data-bs-dismiss": "modal",
                            "aria-label": "Close"
                        })
                    ], -1)),
                    _createElementVNode("div", _hoisted_58, [
                        _cache[26] || (_cache[26] = _createElementVNode("i", { class: "fas fa-exclamation-triangle warning-icon" }, null, -1)),
                        _createElementVNode("p", _hoisted_59, [
                            _createTextVNode(_toDisplayString(_ctx.$t('lists.confirmDeleteCampaign')), 1),
                            _cache[25] || (_cache[25] = _createElementVNode("br", null, null, -1)),
                            _createTextVNode(_toDisplayString(_ctx.$t('lists.confirmDeleteText')), 1)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("button", _hoisted_61, [
                            _cache[27] || (_cache[27] = _createElementVNode("i", { class: "fas fa-times me-2" }, null, -1)),
                            _createTextVNode(_toDisplayString(_ctx.$t('lists.cancel')), 1)
                        ]),
                        _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-danger",
                            onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.confirmationDeleteAction(_ctx.categorieSelected))),
                            "data-bs-dismiss": "modal"
                        }, [
                            _cache[28] || (_cache[28] = _createElementVNode("i", { class: "fas fa-trash-alt me-2" }, null, -1)),
                            _createTextVNode(_toDisplayString(_ctx.$t('lists.delete')), 1)
                        ])
                    ])
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_62, [
            _createElementVNode("div", _hoisted_63, [
                _createElementVNode("div", _hoisted_64, [
                    _createElementVNode("div", _hoisted_65, [
                        _createElementVNode("h5", _hoisted_66, [
                            _cache[30] || (_cache[30] = _createElementVNode("i", { class: "fas fa-chart-bar me-2" }, null, -1)),
                            _createTextVNode(" Rapport de Campagne : " + _toDisplayString(_ctx.selectedCampaign?.title), 1)
                        ]),
                        _cache[31] || (_cache[31] = _createElementVNode("button", {
                            type: "button",
                            class: "btn-close btn-close-white",
                            "data-bs-dismiss": "modal",
                            "aria-label": "Close"
                        }, null, -1))
                    ]),
                    _createElementVNode("div", _hoisted_67, [
                        (_ctx.loadingReport)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_68, [...(_cache[32] || (_cache[32] = [
                                    _createElementVNode("div", {
                                        class: "spinner-border text-primary",
                                        role: "status"
                                    }, null, -1),
                                    _createElementVNode("p", { class: "mt-3 text-muted" }, "Chargement des données...", -1)
                                ]))]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_69, [
                                _createElementVNode("div", _hoisted_70, [
                                    _createElementVNode("div", _hoisted_71, [
                                        _createElementVNode("div", _hoisted_72, [
                                            _createElementVNode("h3", _hoisted_73, _toDisplayString(_ctx.selectedCampaign?.delivered_count || 0), 1),
                                            _cache[33] || (_cache[33] = _createElementVNode("small", {
                                                class: "text-muted text-uppercase fw-bold",
                                                style: { "font-size": "10px" }
                                            }, "Emails Livrés", -1))
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_74, [
                                        _createElementVNode("div", _hoisted_75, [
                                            _createElementVNode("h3", _hoisted_76, _toDisplayString(_ctx.selectedCampaign?.opened_count || 0), 1),
                                            _cache[34] || (_cache[34] = _createElementVNode("small", {
                                                class: "text-muted text-uppercase fw-bold",
                                                style: { "font-size": "10px" }
                                            }, "Ouvertures", -1))
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_77, [
                                        _createElementVNode("div", _hoisted_78, [
                                            _createElementVNode("h3", _hoisted_79, _toDisplayString(_ctx.selectedCampaign?.clicked_count || 0), 1),
                                            _cache[35] || (_cache[35] = _createElementVNode("small", {
                                                class: "text-muted text-uppercase fw-bold",
                                                style: { "font-size": "10px" }
                                            }, "Clics", -1))
                                        ])
                                    ])
                                ]),
                                _cache[38] || (_cache[38] = _createElementVNode("h6", { class: "mb-3" }, [
                                    _createElementVNode("i", { class: "fas fa-list me-2" }),
                                    _createTextVNode(" Activité des destinataires")
                                ], -1)),
                                _createElementVNode("div", _hoisted_80, [
                                    _createElementVNode("table", _hoisted_81, [
                                        _cache[37] || (_cache[37] = _createElementVNode("thead", { class: "bg-light sticky-top" }, [
                                            _createElementVNode("tr", null, [
                                                _createElementVNode("th", null, "Email"),
                                                _createElementVNode("th", null, "Événement"),
                                                _createElementVNode("th", { class: "text-end" }, "Date / Heure")
                                            ])
                                        ], -1)),
                                        _createElementVNode("tbody", null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reportData, (event) => {
                                                return (_openBlock(), _createElementBlock("tr", {
                                                    key: event.id
                                                }, [
                                                    _createElementVNode("td", _hoisted_82, _toDisplayString(event.email), 1),
                                                    _createElementVNode("td", null, [
                                                        _createElementVNode("span", {
                                                            class: _normalizeClass([_ctx.getEventBadgeClass(event.event_type), "badge px-2 py-1"])
                                                        }, _toDisplayString(_ctx.getEventLabel(event.event_type)), 3)
                                                    ]),
                                                    _createElementVNode("td", _hoisted_83, _toDisplayString(_ctx.convertDateCreate(event.created_at, "dd/MM HH:mm:ss")), 1)
                                                ]));
                                            }), 128)),
                                            (_ctx.reportData.length === 0)
                                                ? (_openBlock(), _createElementBlock("tr", _hoisted_84, [...(_cache[36] || (_cache[36] = [
                                                        _createElementVNode("td", {
                                                            colspan: "3",
                                                            class: "text-center py-4 text-muted"
                                                        }, " Aucun événement enregistré pour cette campagne. ", -1)
                                                    ]))]))
                                                : _createCommentVNode("", true)
                                        ])
                                    ])
                                ])
                            ]))
                    ]),
                    _cache[39] || (_cache[39] = _createElementVNode("div", { class: "modal-footer border-0" }, [
                        _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-outline-secondary",
                            "data-bs-dismiss": "modal"
                        }, "Fermer")
                    ], -1))
                ])
            ])
        ])
    ], 64));
}
